import { render, staticRenderFns } from "./corder.vue?vue&type=template&id=7f98ad8c&scoped=true"
import script from "./corder.vue?vue&type=script&lang=js"
export * from "./corder.vue?vue&type=script&lang=js"
import style0 from "./corder.vue?vue&type=style&index=0&id=7f98ad8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f98ad8c",
  null
  
)

export default component.exports